import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_color_pop_living_room: FaireThemeEntity = {
  token: "discovery_theme_color-pop-living-room",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Color Pop Living Room",
  description: "Bold hues to brighten up living spaces",
  bgColor: "#D4EEF0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
